import SecurityPage from "../../design-system/pages/security"

export default SecurityPage